export default "__VITE_ASSET__KHeO6PN$__"